import React from 'react';
import PageTop from '../../../core/components/PageTop';
import { PageTopBreadcrumb } from '../../../core/components/types';
import { useGroupsCreateInit } from './pagehooks/useGroupsCreateInit';
import { ROUTE_LIST } from '../groups_const';
import { useGroupsCreateStore } from './pagehooks/useGroupsCreateStore';
import FormAccountSection from './form/FormAccountSection';
import FormMembersSection from './form/FormMembersSection';
import Panel from '../../../core/components/Panel';

const PageAdminGroupsCreate = (): JSX.Element => {
    useGroupsCreateInit();

    const {
        state: { title },
    } = useGroupsCreateStore();
    const breadcrumb: PageTopBreadcrumb = {
        title: 'Return to Group List',
        icon: 'sprite-list',
        route: ROUTE_LIST,
    };

    return (
        <>
            <PageTop
                title={title}
                icon="sprite-about-corp"
                breadcrumb={breadcrumb}
            />
            <div className="groups-feature groups-edit">
                <Content />
            </div>
        </>
    );
};

const Content = (): JSX.Element => {
    return (
        <Panel flexDirection="row">
            <FormAccountSection />
            <FormMembersSection />
        </Panel>
    );
};

export default PageAdminGroupsCreate;
